module.exports = __webpack_public_path__ + "static/media/token-v2-3d.44a16bd6.png";